import React, {useState} from 'react';
import DashboardHeader from '../DashboardHeader/DashboardHeader.js';

import './Rules.css';


const RulesSection = (props) => {
  const [open, setOpen] = useState(false);

  return(
    <div className="Rules__section ">
      <div className="Rules__section__content">
        <h3 className={`Rules__section__question `+(open ? 'active' : '')} onClick={() => setOpen(!open)}>{props.question}</h3>
        <div className={`Rules__section__answear `+(open ? 'active' : '')}>{props.children}</div>
      </div>
    </div>
  )
}

const Rules = (props) => {
  console.log('+++', props.categories);

  const showConversion = (type, caloriesPerUnit) => {
    let unit, points;
    switch(type){
      case 1:
        unit = '1h';
        points = 60*caloriesPerUnit / 40;
        break;
      case 2:
        unit = '5km';
        points = 5*caloriesPerUnit / 40
        break;
      default:
        unit = '1h';
        points = 60*caloriesPerUnit / 40;
        break;
    }
    return (unit + ' = ' + parseFloat(points.toFixed(1)) + ' points');
  }

  return (
    <React.Fragment>
      <DashboardHeader
        header="Rules"
        user={props.user}
      />
      <div className="Dashboard-content Rules">
        <RulesSection question="How can I track my activities?">
          <p>Those who want to participate have two options:</p>
          <ol>
            <li>Add your activities manually in the Burn for Money app. If you use this option there is no need to synchronise with Strava, although you can choose to do so later if you want to.</li>
            <li>Download the Strava fitness app and join the BfM club. Synchronise your Strava account with BfM during your first login or later in your profile. Then record your activities in Strava as normal – everything will be automatically updated to BfM. Remember to give BfM permission to access your Strava account during synchronisation. Without it BfM will not be able to update automatically.</li>
          </ol>
        </RulesSection>

        <RulesSection question="What disciplines can I track?">
          <p>Currently BfM allows you to track 24 specific disciplines. If you can’t find your chosen activity, you can always use the safe option called "other". You can log any activity under this category as long as it meets one condition - it has to involve some level of physical effort (e-sports don’t count).</p>
        </RulesSection>

        <RulesSection question="How many points do I get for an activity?">
          <p>The point system:</p>

          <div className="Rules__table">
            {props.categories.length > 0 && props.categories.map( i => (
              <div className="Rules__table__row" key={i.name}>
                  <div className="Rules__table__icon"><img src={i.icon} alt={i.displayName} className="Rules__table__iconImage" /></div>
                  <div className="Rules__table__discipline">
                    {i.displayName}
                    <span className="Rules__table__discipline--description">{i.description}</span>
                  </div>
                  <div className="Rules__table__conversion">{showConversion(i.type, i.caloriesPerUnit)}</div>
              </div>
            ))
            }
          </div>
        </RulesSection>

        <RulesSection question="How are points calculated?">
          <p>There are two types of disciplines:</p>
          <ol>
            <li>Distance-related (walking, running, cycling) for which you track kilometers</li>
            <li>Time-related (remaining activities) for which you track minutes or hours</li>
          </ol>
          <p>Each activity is converted from distance/duration to calories based on an average rate, specific for each discipline. This rate is based on the average number of calories burned during a particular activity by an average person (male, 70 kg, 30 years old). This step allows you to reward your effort while doing more demanding sports. Calories are converted to points and then to money, based on these rates: </p>

          <p className="conversion">
            40 kcal = 1 point<br/>
            500 points = 100 PLN
          </p>

          <p>Your effort matters!</p>
          <p>If you know how many calories you burned during an activity you can enter the exact number manually. The app will then use your specified value instead of the average exchange rates. This way, you can be sure that the app doesn’t miss any of your burned calories 😊</p>
          <p>If you track your calories in Strava they will be used to calculate your points. In that case, distance and time are only kept for statistics.</p>

          <p>Let’s have a look at a few specific examples:</p>
          <p>I ran 10 km. I didn’t track my calories. I added an activity in the Burn for Money application manually. 16.2 points where added to my account.</p>
          <p>I ran 10 km. I tracked my training in Strava. It registered that I burned 1200 kcal. I earned 30 points. They were added to my BfM account automatically because I have synced my Strava account with the BfM app.</p>
          <p>I ran 10 km. I tracked my training in Endomondo. It registered that I burned 1200 kcal. I manually added an activity in BfM providing not only distance, but also calories. I earned 30 points.</p>
        </RulesSection>

        <RulesSection question="How do we choose beneficiary?">
          <p>After every month the system randomly picks a person who can select a BfM beneficiary. The same person may be chosen more than once. You choose a beneficiary according to the rules defined in this section.</p>
          <p>In addition, a list of ‘recommended’ organisations is available on SharePoint. All employees are welcome to add people or organisations they would like to support and give a short description.</p>
          <p>The basic rule is that we help people and animals who need money to satisfy their basic needs. In other words - they need help to survive. We also want a beneficiary that is located in Poland.</p>
          <p>We don’t support organizations or causes that may lead to conflicts and divide people. We want to avoid situations where a controversial choice can provoke arguments, destroy the atmosphere and discourage people from participating in BfM.</p>
        </RulesSection>
      </div>
    </React.Fragment>
  );
}

export default Rules;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/Rules/Rules.js